import CasesPage from 'routes/Private/Cases/CasesPage'
import React, { ReactElement } from 'react'
import { EListType } from 'lib/entities/Case'

export default function InReviewList(): ReactElement {
	return <CasesPage listType={EListType.inReview} />
}
